import Main from '@/views/administracion/configuracion/catalogos/usuarios/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/usuarios/Default.vue';
import MainUsuario from '@/views/administracion/configuracion/catalogos/usuarios/usuario/Main.vue';
import DefaultUsuario from '@/views/administracion/configuracion/catalogos/usuarios/usuario/Default.vue';

// const auth = ['Seguridad:ver'];
const scopes = ['Seguridad:crear', 'Seguridad:editar', 'Seguridad:eliminar'];

const usuarios = [
  {
    path: 'usuarios',
    meta: {
      title: '',
      auth: [],
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoUsuarios',
        path: '/',
        meta: {
          title: 'Usuarios',
          auth: [],
          scopes,
        },
        component: Default,
        children: [],
      },
      {
        path: ':id',
        meta: {
          title: 'Usuario',
          auth: [],
          scopes,
        },
        component: MainUsuario,
        children: [
          {
            name: 'usuario',
            path: '/',
            meta: {
              title: 'Usuario',
              auth: [],
              scopes,
            },
            component: DefaultUsuario,
          },
        ],
      },
    ],
  },
];

export default usuarios;
